import { Data } from 'effect'

/** The browser could not read a user-selected file or directory entry. */
export class FileReadError extends Data.TaggedError('FileReadError')<{
  cause: unknown
}> {}

/** The selected bytes are not a ZIP archive that this client can decode. */
export class InvalidArchiveError extends Data.TaggedError('InvalidArchiveError')<{
  cause: unknown
}> {}

/** User-controlled archive metadata cannot be represented by the ZIP format. */
export class ArchiveGenerationError extends Data.TaggedError('ArchiveGenerationError')<{
  cause: unknown
}> {}
